import { FC } from 'react';
import Link from 'next/link';
import { RUSSIAN_ALPHABET, ENGLISH_ALPHABET } from '@/helpers/variables';
import styles from './AlphabetSearch.module.scss';

interface IReviewCard {
  url: string;
}

const AlphabetSearch: FC<IReviewCard> = ({ url }) => {
  return (
    <div className={styles.alphabetSearch}>
      <div className={styles.alphabetSearch__title}>По алфавиту</div>
      <div className={styles.alphabetSearch__wrap}>
        <div className={styles.alphabetSearch__row}>
          {RUSSIAN_ALPHABET.map((word) => (
            <Link prefetch={false} key={word} className={styles.alphabetSearch__link} href={`${url}${word.toLowerCase()}`}>
              {word}
            </Link>
          ))}
        </div>
        <div className={styles.alphabetSearch__row}>
          {ENGLISH_ALPHABET.map((word) => (
            <Link prefetch={false} key={word} className={styles.alphabetSearch__link} href={`${url}${word.toLowerCase()}`}>
              {word}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AlphabetSearch;
